import { defineMessages } from 'react-intl';

export default defineMessages({
    
    emailAddress : {
        id: "ri.gateway.BillingDelivery.Email Address",
        defaultMessage: "Email Address"
    },

    deliveryMethod : {
        id: "ri.gateway.BillingDelivery.Delivery Method",
        defaultMessage: "Delivery Method"
    },
    deliveryTitle : {
        id: "ri.gateway.BillingDelivery.Billing Delivery",
        defaultMessage: "Billing Delivery"
    },
    deliveryByMail : {
        id: "ri.gateway.BillingDelivery.Mail",
        defaultMessage: "Sent in the mail"
    },
    deliveryByEmail : {
        id: "ri.gateway.BillingDelivery.Email",
        defaultMessage: "Sent by email"
    },
    addEmailButton : {
        id: "ri.gateway.BillingDelivery.Add",
        defaultMessage: "+ Add"               
    },    
    updating : {
        id: "ri.gateway.BillingDelivery.Processing updating ...",
        defaultMessage: "Processing updating ..."        
    },
    updated : {
        id: "ri.gateway.BillingDelivery.The Billing Delivery is updated!",
        defaultMessage: "The Billing Delivery is updated!"        
    },       
    error : {
        id: "ri.gateway.BillingDelivery.Internal error, updating failed!",
        defaultMessage: "Internal error, updating failed!"        
    },
    noEmailAddress : {
        id: "ri.gateway.BillingDelivery.No email address",
        defaultMessage: "No email address"        
    },
    mustHaveEmail : {
        id: "ri.gateway.BillingDelivery.Need to add at least one email",
        defaultMessage: "Need to add at least one email"        
    }    
});
